import { type SearchItemProps } from '4-sections/SearchSection/SearchItem';
import { type SearchBlockQuery } from 'cms/cms';
import { resolvePageBaseToSearchItem, type PageBase, type PageBaseItems, type SearchItemResolverSettings } from './searchItemResolver';

export interface SearchCount {
    name: string;
    count: string;
}

interface SearchBlockData {
    total: number;
    searchCounts: SearchCount[];
    ancestorCounts: SearchCount[];
    items: SearchItemProps[];
}

export const resolveSearchBlock = (data: SearchBlockQuery, settings?: SearchItemResolverSettings): SearchBlockData | null => {
    const { items, total, facets } = data.PageBase as PageBase;

    const searchCounts = facets?.ContentType as unknown as SearchCount[] || [];

    return {
        total: Number(total),
        searchCounts,
        ancestorCounts: facets?.Ancestors as unknown as SearchCount[] || [],
        items: resolvePageBaseToSearchItem(items as PageBaseItems, settings),
    };
};
